var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitalMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5349 7.46655C29.2016 12.1332 29.2016 19.7332 24.5349 24.3999C19.8682 29.0666 12.2682 29.0666 7.60156 24.3999C2.9349 19.7332 2.9349 12.1332 7.60156 7.46655C12.2682 2.79989 19.7349 2.79989 24.5349 7.46655",
    stroke: "#2B2D42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9987 20H9.9987C9.5987 20 9.33203 19.7333 9.33203 19.3333V13.3333C9.33203 12.8 9.9987 12.4 10.3987 12.8L13.0654 14.9333L15.4654 12.4C15.732 12.1333 16.132 12.1333 16.3987 12.4L18.7987 14.9333L21.4654 12.8C21.8654 12.4 22.532 12.8 22.532 13.3333V19.3333C22.6654 19.7333 22.3987 20 21.9987 20V20Z",
    stroke: "#EF233C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarket);
export default __webpack_public_path__ + "static/media/DigitalMarket.d554bfca5ed1d80e30b47ff4cea14a7a.svg";
export { ForwardRef as ReactComponent };